"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orVobFilter = exports.andVobFilter = exports.getRejectionBucketingFilter = exports.getTypeFilter = exports.existsFilter = void 0;
const existsFilter = (x) => !!x;
exports.existsFilter = existsFilter;
const getTypeFilter = (type) => (x) => x.type === type;
exports.getTypeFilter = getTypeFilter;
/** returns a filter that will dump rejections that FAIL the filter into provided bucket
 * @typeParam T - Type of item to be filterd and type of rejection bucket array
 * @param filter - The filter to run on provided items
 * @param rejectionsBucket - An array to push filterd items to
 * @returns A filter function that pushes failed items to an array
 * @example
 * Filtering a list of objects and getting everything that isn't a dog
 * ```
 * const notDogs: any[] = [];
 * const dogFilter = getRejectionBucketingFilter({ filter: item => item.type === 'Dog', rejectionsBucket: notDogs });
 * const dogs = [unfilteredItems].filter(dogFilter);
 * ```
 * */
const getRejectionBucketingFilter = ({ filter, rejectionsBucket }) => (item, i, arr) => {
    let passes;
    if (filter.length === 3) {
        passes = filter(item, i, arr);
    }
    else if (filter.length === 2) {
        passes = filter(item, i);
    }
    else {
        passes = filter(item);
    }
    if (!passes) {
        rejectionsBucket.push(item);
    }
    return passes;
};
exports.getRejectionBucketingFilter = getRejectionBucketingFilter;
const andVobFilter = (filters) => (vob) => filters.map((filter) => filter(vob)).every((res) => !!res);
exports.andVobFilter = andVobFilter;
/** produces a single 'and' filter for vobs from a set of vob filters */
const orVobFilter = (filters) => (vob) => filters.map((filter) => filter(vob)).some((res) => !!res);
exports.orVobFilter = orVobFilter;
